import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-data-table-column-options',
	templateUrl:'./DataTableColumnOptionsPluginCompPage.html',
	styles: [],
	styleUrls:['./DataTableColumnOptionsPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class DataTableColumnOptionsPluginCompPage
{
	mdContent_885 = `\`\`\`java
import com.jwebmp.plugins.datatable.options.DataTableColumnOptions;
\`\`\``;
	mdContent_886 = `\`\`\`java
DataTableColumnOptions(DataTableOptions&lt;?&gt; tableOptions)
\`\`\``;
	mdContent_887 = `\`\`\`java
DataTableColumnOptions&lt;?&gt; col = new DataTableColumnOptions&lt;&gt;(opts);
col.setData("name")
   .setTitle("Full Name")
   .setOrderable(DataTablesSortables.True)
   .setSearchable(true)
   .setWidth("200px");
\`\`\``;
	mdContent_888 = `\`\`\`java
DataTableColumnOptions&lt;?&gt; col = new DataTableColumnOptions&lt;&gt;(opts);
col.setData("id")
   .setTitle("ID")
   .setVisible(false);
\`\`\``;
}
